import{defineMessages}from"react-intl";export var messages=defineMessages({noDetails:{id:"jutro-dataview.Expansion.noDetails",defaultMessage:"No details"}});